import React from 'react'

interface Props {
    children?: React.ReactNode
}
const HorizontalCardImageRightTop: React.FC<Props> = props => {
    return <>{props.children}</>
}

export default HorizontalCardImageRightTop
